const budgetActionOptions = [
  { value: 'set', text: 'Set Budget To' },
  { value: 'increase', text: 'Increase Budget By' },
  { value: 'decrease', text: 'Decrease Budget By' },
];

const budgetUnitOptions = [
  { value: 'static', text: '$' },
  { value: 'percentage', text: '%' },
];

const budgetToOptions = [
  { value: 'budget', text: 'of Current Budget' },
];

const budgetModelTemplates = {
  classic: {
    action: {
      set: {
        unit: {
          static: {},
        },
      },
      increase: {
        unit: {
          static: {},
          percentage: {
            to: {
              budget: {},
            },
          },
        },
      },
      decrease: {
        unit: {
          static: {},
          percentage: {
            to: {
              budget: {},
            },
          },
        },
      },
    },
  },
};

module.exports = {
  budgetActionOptions, budgetUnitOptions, budgetToOptions, budgetModelTemplates,
};
